import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils/classnames.js';
function FallbackLogo({ displayName, className, fontSize }) {
    return (_jsx("div", { className: cn('ui-flex ui-size-full ui-items-center ui-justify-center ui-rounded-full ui-bg-black ui-font-bold ui-uppercase ui-leading-none', className), children: _jsx("span", { style: { fontSize }, children: displayName[0] }) }));
}
export default FallbackLogo;
